import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { reduxForm, Field } from 'redux-form';
import { Grid } from './../../../themes/default';
import { Section, Content, Main, Buttons, FormContent, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Ttolbar } from './../../../components/includes/ui/table';
import { InputTextField, SelectField, OptionField } from './../../../components/includes/ui/input';
import { Btn } from './../../../components/includes/ui';
import { ProductService } from './../../../services';

import VALIDATION from './../../../config/validation';

const validate = values => {

  const errors = {}

  if (!values.name) {
    errors.name = VALIDATION.required;
  }else if(values.name.length > 2048){
    errors.name = VALIDATION.maxlength;
  }

  if (!values.title) {
    errors.title = VALIDATION.required;
  }else if(values.title.length > 2048){
    errors.title = VALIDATION.maxlength;
  }

  if (values.subtitle) {
    if(values.subtitle.length > 2048){
      errors.subtitle = VALIDATION.maxlength;
    }
  }

  if (values.status === '-1') {
    errors.status = VALIDATION.required;
  }

  return errors

};

class ProductCreate extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      sending: false
    };
  }

  /*
  ** @Service
  ** @Description: New
  */

  _Create = (values) => {

    /**
    * @State
    */
    this.setState({ sending: true });

    ProductService.create(values).then((response) => {

      /**
      * @Service find all by page
      */
      this.props.history.push(`/products/update/${ response.product._id }?status=new`);

      /**
      * @Dispatch for alert success message
      */
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el producto fue creado.` });

    }).catch((error) => {

      /**
      * @State
      */
      this.setState({ sending: false });

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: error.data.message });

    });

  }

  /*
  ** @Service
  ** @Description: Submit form
  */
  handleSubmitForm = (values) => {
    this._Create(values);
  }

  render() {

    const { sending } = this.state;
    const { handleSubmit, invalid } = this.props;

    return (
      <Section>
        <ToolbarPrimary title="Productos"/>
        <BreadcrumbItem to='/products'>Productos</BreadcrumbItem>
        <BreadcrumbItem to='/create'>Crear</BreadcrumbItem>
        <Content>

          <Main>

            <form noValidate autoComplete="off" onSubmit={ handleSubmit(this.handleSubmitForm) }>

              <Ttolbar title="Creación de producto"/>

              <FormContent enabledActions>

                <Grid container spacing={24}>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="name"
                        component={ InputTextField }
                        label="Nombre"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Field
                        name="status"
                        component={ SelectField }
                        label="Estado" required>
                          <OptionField key="-1" value="-1">Seleccionar...</OptionField>
                          <OptionField key="true" value="true">Activo</OptionField>
                          <OptionField key="false" value="false">Bloqueado</OptionField>
                    </Field>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Field
                        name="title"
                        component={ InputTextField }
                        label="Título"
                        type="text"
                        required
                    />
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Field
                        name="subtitle"
                        component={ InputTextField }
                        label="Sub-Titulo"
                        type="text"
                    />
                  </Grid>

                </Grid>

              </FormContent>

              <FormActions>
                <Grid container>
                  <Grid item lg={6} md={6} sm={12}>
                    <Buttons>
                      <Btn aria-label="Volver" icon="back" color="secondary" component={ NavLink } to="/products">
                        Volver
                      </Btn>
                    </Buttons>
                  </Grid>
                  <Grid item lg={6} md={6} sm={12}>
                    <Buttons align="right">
                      <Btn aria-label="Guardar" icon="add" color="success" type="submit" disabled={ invalid } loading={ sending }>
                        Guardar
                      </Btn>
                    </Buttons>
                  </Grid>
                </Grid>
              </FormActions>

            </form>

          </Main>

        </Content>
      </Section>
    )
  }
}

ProductCreate = reduxForm({
  form: 'ProductCreate',
  validate,
  initialValues: {
    status: '-1',
    template: '-1'
  }
})(ProductCreate);

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductCreate);
